<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let facilities = data?.facilities;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);

	});
</script>

<svelte:head>
	<title>Facilities - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="https://balinusadua.holidayinnresorts.com/en/amenities">
</svelte:head>

<Navbar />

<FastBtn />

<section id="amenities">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src="/img/bg-header-facilities-new.webp"
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<!-- <div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<h1 class="ff-lola-bir display-3 mb-3">Amenities</h1>
					</div>
				</div> -->
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0 amenities-welcome position-relative">
		<div class="row g-0 justify-content-center mt-md-5 mt-4 mb-md-5 mb-5">
			<div class="col-md-10 px-md-5 px-3 text-center">
				<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">
					{$_('facilities_title_1')}
				</p>
				<p class="line mb-md-4 mb-3 mx-auto"></p>
				<p class="ff-helvetica">
					{$_('facilities_desc_1')}
				</p>
			</div>
		</div>
		<!-- Desktop -->
		<div class="row g-0 d-md-flex d-none">
			<div class="col-md-7 p-md-5 pe-md-0 bg-overlay position-relative">
				<div class="tab-content" id="myTabContent">
					{#each facilities as facility,index}
					<div
						class="tab-pane fade {index === 0 ? 'show active' : ''}"
						id="tab-{facility.slug}"
						role="tabpanel"
						aria-labelledby="tab-{facility.slug}"
						tabindex="0"
					>
						<div class="ratio ratio-16x9 position-relative">
							<img alt="Holiday Inn Resort Nusa Dua" src="{facility.featured_images[0].path}" class="w-100 h-100 object-fit-cover" />
							<div
								class="text-section position-absolute top-0 start-0 w-100 h-100 row g-0 align-items-center p-md-4 p-3"
							>
								<div class="col-md-8">
									<p class="mb-2 text-white fs-1 pe-md-3 ff-lola-bir mb-md-2 lh-2">
										{facility.name}
									</p>
									<p class="line mb-md-3 mb-2 border-light"></p>
									<p class="mb-md-4 ff-helvetica text-white">
										{facility.excerpt}
									</p>
									<p class="ff-lola-r">
										<a data-sveltekit-reload href="/{lang}/facilities/{facility.slug}" class="btn btn-outline-light rounded-0"
											>{$_('btn_view_details')}</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>
					{/each}
				</div>
			</div>
			<div
				class="col-md-5 align-self-stretch main-bg row g-0 justify-content-center align-items-center"
			>
				<div class="col-12 text-white p-md-5 p-3">
					<p class="mb-3 display-5 ff-lola-bir mb-md-5 lh-1">{$_('facilities_title_2')}</p>
					<div id="myTab" role="tablist" class="ff-lola-mr fs-4">
						{#each facilities as facility,index}
						<p>
							<a
								href=""
								class="nav-link {index === 0 ? 'active' : ''}"
								data-bs-toggle="tab"
								data-bs-target="#tab-{facility.slug}"
								role="tab"><span class="text-uppercase">{facility.name}</span></a
							>
						</p>
						{/each}
					</div>
				</div>
			</div>
		</div>
		<!-- Mobile -->
		<div class="row g-0 d-flex d-md-none">
			<div class="col-12 mb-4">
				<p class="mb-2 main-color display-3 pe-md-3 ff-lola-bir lh-2 text-center">{$_('facilities_title_2')}</p>
				<p class="line mx-auto"></p>
			</div>
			<div class="col-12 row g-0 px-3">
				<div class="col-12 row g-0 align-items-center mb-3 main-color">
					<div class="col-1 nav-slider-highlight">
						<span class="btn-prev"><i class="ph-bold ph-caret-left"></i></span>
					</div>
					<div class="col-10 px-4">
						<div class="swiper slider-highlight-title">
							<div class="swiper-wrapper align-items-center">
								{#each facilities as facility,index}
								<div class="swiper-slide">
									<p class="ff-lola-bir fs-1 text-center mb-0">{facility.name}</p>
								</div>
								{/each}
							</div>
						</div>
					</div>
					<div class="col-1 nav-slider-highlight text-custom">
						<span class="btn-next"><i class="ph-bold ph-caret-right"></i></span>
					</div>
				</div>
				<div class="col-12">
					<div class="swiper slider-highlight-img">
						<div class="swiper-wrapper">
							{#each facilities as facility,index}
							<div class="swiper-slide">
								<div class="ratio-3x4 rounded-4 position-relative">
									<img alt="Holiday Inn Resort Nusa Dua" src="{facility.featured_images[0].path}" class="w-100 h-100 object-fit-cover rounded-4" />

									<div
										class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center text-img-highlight p-4 rounded-4"
									>
										<div class="text-center">
											<p class="mb-2 fs-1 text-white ff-lola-bir lh-2 text-center">
												{facility.name}
											</p>
											<p class="line mx-auto mb-2 border-light"></p>
											<p class="text-white mb-0">
												<small
													>{facility.excerpt}</small
												>
											</p>
										</div>
									</div>
								</div>
							</div>
							{/each}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container featured-amenities py-md-5 py-4">
		<div class="row g-0 justify-content-center">
			<div class="col-md-10 text-center">
				<p class="mb-3 main-color display-3 pe-md-3 ff-lola-bir mt-md-5 lh-2">{$_('facilities_title_3')}</p>
				<p class="line mb-md-5 mb-4 mx-auto"></p>
			</div>
			<div class="col-md-10 row g-0">
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-baby fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_1')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-island fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_2')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-spray-bottle fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_3')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-barbell fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_4')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-traffic-cone fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_5')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-swimming-pool  fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_6')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-fork-knife fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_7')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-flower-lotus fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_8')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-cigarette-slash fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_9')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-wifi-high fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_10')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-bus fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_11')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-castle-turret fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_12')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-game-controller fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_13')} </span>
				</div>
				<div class="col-md-4 col-6 d-flex align-items-center p-3">
					<div class="icon p-2 me-2">
						<i class="ph-light ph-beer-stein fs-4"></i>
					</div>
					<span class="main-color ff-lola-bir fs-5 ms-1 lh-1"> {$_('fa_14')} </span>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer award={award}/>

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.amenities-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #451C70;
		width: 25%;
	}
	.featured-amenities .icon {
		background-color: #ebe5ef;
		color: #451C70;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.amenities-welcome .bg-overlay:after {
		content: '';
		position: absolute;
		top: 0;
		right: -2px;
		height: 100%;
		width: 20%;
		background-color: #451C70;
		z-index: -1;
	}
	.amenities-welcome .nav-link.active {
		position: relative; /* Penting untuk pseudo-element */
	}

	.amenities-welcome .nav-link.active::before {
		content: '';
		position: absolute;
		top: 50%; /* Posisi garis vertikal di tengah */
		left: 0; /* Mulai dari kiri */
		width: 60px; /* Lebar garis */
		height: 2px; /* Tinggi garis */
		transform: translateY(-50%); /* Agar sejajar dengan teks */
		background-color: white; /* Warna garis */
		border-radius: 1px; /* Opsional: Melengkungkan sedikit sudut */
		transition: all 0.3s ease; /* Animasi untuk garis */
	}

	.amenities-welcome .nav-link.active span {
		display: inline-block; /* Penting agar bisa bergeser */
		margin-left: 70px; /* Geser ke kanan */
		transition: margin-left 0.3s ease; /* Animasi untuk pergeseran */
	}

	.amenities-welcome .nav-link:not(.active) span {
		margin-left: 0; /* Kembalikan ke posisi awal jika tidak aktif */
		transition: margin-left 0.3s ease; /* Pastikan ada transisi juga */
	}

	.amenities-welcome .nav-link:not(.active)::before {
		width: 0; /* Garis menghilang saat tidak aktif */
		transition: all 0.3s ease; /* Pastikan transisi halus untuk garis */
	}
	.amenities-welcome .text-section {
		background-image: linear-gradient(
			to right,
			rgba(0, 0, 0, 0.7),
			rgba(0, 0, 0, 0.5),
			rgba(0, 0, 0, 0)
		);
	}
	@media (max-width: 600px) {
		.amenities-welcome {
			position: relative;
		}
		.amenities-welcome::after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 40%;
			background-color: #451C70;
		}
		.amenities-welcome .nav-slider-highlight span {
			font-size: 28px;
		}
		.amenities-welcome .slider-highlight-img .text-img-highlight {
			background-image: linear-gradient(
				to top,
				rgba(0, 0, 0, 0.8),
				rgba(0, 0, 0, 0.5),
				rgba(0, 0, 0, 0)
			);
		}
	}
</style>
